/**
 * IMPORTANT:
 * This mapping is used to trigger the Hotjar survey based on the route.
 * If there are multiple routes matching the same URL and query params, the first one will be triggered.
 */
export const routeTriggerMapping = {
  '/library/employee-assistance': 'support-resources-main-page',
  '/wellbeing': 'wellbeing-main-page',
  '/programs': 'carenow-main-page',
  '/assessments': 'assessments-main-page',
  '/challenges': 'challenges-main-page',
  '/tiering': 'tiering-main-page',
  '/offers/tiering-rewards': 'rewards-main-page',
  '/home': 'home-page',
  '/wellbeing/recommendations': 'wellbeing-recommendations-main-page',
  '/perks-home-page': 'perks-main-page',

  // TODO: These are the old Wondering mappings.
  // TODO: We keep them now because we might need to use them later with Hotjar.
  // // Corporate challenges
  // '/challenges/corporate/:challengeId': 'challenges-corporate-info-and-join',
  // '/challenges/corporate/:challengeId/activity':
  //   'challenges-corporate-steps-activity',
  // '/challenges/habit/:challengeId/activity/corporate':
  //   'challenges-corporate-habit-activity',
  // '/challenges/habit/:challengeId/select-habits?participationType=corporate':
  //   'challenges-corporate-select-habits',

  // // Individual challenges
  // '/challenges/individual/:challengeId': 'challenges-individual-info-and-join',
  // '/challenges/individual/:challengeId/activity':
  //   'challenges-individual-steps-activity',
  // '/challenges/habit/:challengeId/activity/individual':
  //   'challenges-individual-habit-activity',
  // '/challenges/habit/:challengeId/select-habits?participationType=individual':
  //   'challenges-individual-select-habits',

  // // Employee assistance
  // '/life/employee-assistance/search': 'employee-assistance-search-result',

  // // Programs
  // '/programs/:programId': 'program-detail',
  // '/programs/:programId/modules/:moduleId': 'program-module-detail',
  // '/programs/:programId/overview/:moduleOverviewId': 'program-detail-overview',
  // '/programs/:programId/menu': 'program-menu',

  // //Assessments
  // '/assessments/:assessment_id': 'assessment-detail',
  // '/assessments/:assessment_id/details': 'assessment-result',
  // '/assessments/:assessment_id/details/:archive_id':
  //   'assessment-historical-result',

  // //News feed
  // '/feed': 'news-feed-main-page',

  // // My Care
  // '/my-care': 'my-care',
  // '/my-care/assessments': 'my-care-assessments',
  // '/my-care/other-services': 'my-care-other-services',

  // // Mood Tracking
  // '/mood-tracking/history': 'mood-tracking-history',
  // '/mood-tracking/new-entry': 'mood-tracking-new-entry',

  // // Journal
  // '/journal/history': 'journal-history',
  // '/journal/new-entry': 'journal-new-entry',

  // // Appointments
  // '/appointments/intro': 'appointments-intro',
  // '/appointments/user-location': 'appointments-user-location',
  // '/appointments/counsellor-selection': 'appointments-counsellor-selection',

  // // Care Plan
  // '/care-plan/overview': 'care-plan-overview',
  // '/care-plan/intro': 'care-plan-intro',

  // // Perks
  // '/offers/in-store': 'perks-top-ten',
  // '/offers/colleague': 'perks-exclusive-offers',
  // '/shop': 'perks-cashback',
  // '/gift-cards': 'perks-gift-cards-all',
  // '/gift-cards/popular': 'perks-gift-cards-popular',
  // '/gift-cards/category/gift_card_children_and_toys':
  //   'perks-gift-cards-category-children-and-toys',
  // '/gift-cards/category/gift_card_department_stores':
  //   'perks-gift-cards-category-department-stores',
  // '/gift-cards/category/gift_card_dining': 'perks-gift-cards-category-dining',
  // '/gift-cards/category/gift_card_electrical':
  //   'perks-gift-cards-category-electrical',
  // '/gift-cards/category/gift_card_fashion': 'perks-gift-cards-category-fashion',
  // '/gift-cards/category/gift_card_health_and_beauty':
  //   'perks-gift-cards-category-health-and-beauty',
  // '/gift-cards/category/gift_card_home_and_garden':
  //   'perks-gift-cards-category-home-and-garden',
  // '/gift-cards/category/gift_card_leisure': 'perks-gift-cards-category-leisure',
  // '/gift-cards/:gift_card_id': 'perks-gift-card-detail',

  // '/shop/retailers/category/onlineshop_electronics':
  //   'perks-cashback-category-electronics',
  // '/shop/retailers/category/onlineshop_fashion':
  //   'perks-cashback-category-fashion',
  // '/shop/retailers/category/onlineshop_food_and_beverage':
  //   'perks-cashback-category-food-and-beverage',
  // '/shop/retailers/category/onlineshop_gifts_and_gift_cards':
  //   'perks-cashback-category-gifts-and-gift-cards',
  // '/shop/retailers/category/onlineshop_health_and_beauty':
  //   'perks-cashback-category-health-and-beauty',
  // '/shop/retailers/category/onlineshop_home_and_garden':
  //   'perks-cashback-category-home-and-garden',
  // '/shop/retailers/category/onlineshop_insurance':
  //   'perks-cashback-category-insurance',
  // '/shop/retailers/category/onlineshop_media': 'perks-cashback-category-media',
  // '/shop/retailers/category/onlineshop_sports':
  //   'perks-cashback-category-sports',
  // '/shop/retailers/category/onlineshop_tickets':
  //   'perks-cashback-category-tickets',
  // '/shop/retailers/category/onlineshop_travel':
  //   'perks-cashback-category-travel',
  // '/shop/retailers/category/onlineshop_utilities':
  //   'perks-cashback-category-utilities',
};
